/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UnlockSmsRateLimitDto } from '../models/UnlockSmsRateLimitDto';
import type { UnlockSmsRateLimitEntity } from '../models/UnlockSmsRateLimitEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CareSoftSmsService {
  /**
   * @param requestBody
   * @returns UnlockSmsRateLimitEntity
   * @throws ApiError
   */
  public static careSoftSmsControllerUnlockRateLimit(
    requestBody: UnlockSmsRateLimitDto,
  ): CancelablePromise<UnlockSmsRateLimitEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/caresoft-sms/rate-limit/unlock',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
